<template>
  <div :class="['header', { headerPosition: headerPosition }]" :back="handleBack">
    <!-- <back-icon :back="handleBack" :black="black"></back-icon> -->
    <div class="back-icon" @click="handleBack" v-if="(!isIos && !androidNoHeade) || isIos">
      <span class="back-img"></span>
    </div>
    <div class="back-icon" v-else></div>
    <div class="header-title">
      <slot class name="title"></slot>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import { getUrlParams } from "src/utils/tool";

const { mm } = window;
export default {
  name: "HeaderTop",
  props: {
    back: {
      type: Function,
      required: false
    },
    borderColor: {
      type: String,
      default: "#ebebeb"
    },
    headerPosition: {
      type: Boolean,
      default: false
    },
    borderControl: {
      type: Boolean,
      default: true
    },
    black: {
      type: Boolean,
      default: false
    },
    judgeExit: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      routerPath: "",
      hasAgree: getUrlParams("hasAgree") || "1",
      isIos: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      androidNoHeade: navigator.userAgent.indexOf("hnVersion") === -1
    };
  },
  mounted() {
    // alert(window.navigator.userAgent);
  },
  methods: {
    handleBack() {
      console.log("close");
      mm.ui.close({
        type: 1 // 默认为1
        // 1 关闭当前webview，2 关闭所有webview，3 关闭之前的webview
      });
    }
  }
};
</script>
<style lang="scss">
.header {
  position: fixed;
  z-index: 100;
  display: flex;
  align-items: center;
  width: 750px;
  padding-top: 6px;
  height: 100px;
  background-color: rgb(246, 245, 251);
  .header-title {
    padding-top: 6px;
    width: 650px;
    margin-left: -50px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    position: relative;
    z-index: 2;
  }
}
.back-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100px;
  flex-grow: 0;
  flex-shrink: 0;
  z-index: 3;
  position: relative;
  .back-img {
    display: block;
    width: 50px;
    height: 50px;
    background-image: url("../assets/images/wallet-icon-back.png");
    background-size: 50px 50px;
    background-position: center;
  }
}
.headerPosition {
  position: absolute;
  z-index: 10;
  padding: 0 30px;
}
</style>
